import firebase from 'firebase/app'
import 'firebase/firestore'

var firebaseConfig = {
    apiKey: "AIzaSyBlsAdWz4uCtNGjTqPyQctdMrTBcSogtLM",
    authDomain: "podcasts-43bb4.firebaseapp.com",
    databaseURL: "https://podcasts-43bb4.firebaseio.com",
    projectId: "podcasts-43bb4",
    storageBucket: "podcasts-43bb4.appspot.com",
    messagingSenderId: "259978061312",
    appId: "1:259978061312:web:0d42bb9683960f75fa1ae5"
  };

  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);


export default firebase